import { Chip } from '@mui/material';
import React from 'react';

import styles from './styles.module.scss';
import { SnapshotInfo } from './uwiqUtils';

export interface ContextSelectorProps {
  snapshots: SnapshotInfo[];
  selectedIdx: number;
  onSelect: (idx: number) => void;
}

const decisionColor = (decision: string): 'success' | 'error' | 'warning' | 'default' => {
  const d = decision.toLowerCase();
  if (d === 'approve') return 'success';
  if (d === 'decline') return 'error';
  if (d === 'ruw') return 'warning';
  return 'default';
};

const ContextSelector = ({ snapshots, selectedIdx, onSelect }: ContextSelectorProps) => {
  if (snapshots.length <= 1) return null;

  return (
    <div className={styles.ContextSelector}>
      {snapshots.map((snap, idx) => (
        <Chip
          key={snap.contextKey}
          label={`${snap.contextDisplayName} (${snap.decision})`}
          variant={idx === selectedIdx ? 'filled' : 'outlined'}
          color={decisionColor(snap.decision)}
          size="small"
          onClick={() => onSelect(idx)}
          clickable
        />
      ))}
    </div>
  );
};

export default ContextSelector;
